module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    class: ['theme-' + _vm.selectedTheme, {
      'rolled-out': _vm.isRolledOut
    }],
    attrs: {
      "id": "active-chats-panel"
    }
  }, [_c('div', [(_vm.activeChatType === 'group') ? _c('group-details') : _vm._e(), _vm._v(" "), _c('user-chats')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e48e4454"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Chatroom/ActiveChatsPanel.vue
// module id = 411
// module chunks = 1